/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOrderingProfileCatalogFilters} from '../api'

 export const useQueryGetOrderingProfileCatalogFilters = createReactQueryHook('getOrderingProfileCatalogFilters', getOrderingProfileCatalogFilters)
